import { render, staticRenderFns } from "./InHouseRepair.vue?vue&type=template&id=36d5488a"
import script from "./InHouseRepair.vue?vue&type=script&lang=js"
export * from "./InHouseRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports